import * as logger from 'loglevel';

if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
  logger.setLevel('debug');
}

export default logger;
